"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateShortId = generateShortId;
const short_id_constants_1 = require("./short-id.constants");
/**
 * Generates a random ShortId (short identifier) following specific rules.
 *
 * This function creates a unique identifier composed of uppercase letters and numbers
 * that are less error-prone in human-readable contexts. Specifically:
 * - Only includes uppercase letters (A, C, D, E, F, G, H, J, K, M, N, P, Q, R, S, T, U, V, W, X, Y, Z)
 *   and numbers (1-9) to avoid confusion with similar-looking characters (e.g., O and 0).
 * - The generated identifier is by default 6 characters long, but can be customized.
 *
 * @param {number} [length=SHORT_ID_LENGTH] - The length of the generated short ID.
 * @returns {string} A randomly generated short ID.
 *
 * @example
 * const shortId = generateShortId(); // "AFK3YQ" (default 6 characters)
 * const longerShortId = generateShortId(8); // "AFK3YQ2T" (8 characters)
 */
function generateShortId(length = short_id_constants_1.SHORT_ID_LENGTH) {
    let code = "";
    for (let i = 0; i < length; i++) {
        code += short_id_constants_1.SHORT_ID_CHARS.charAt(Math.floor(Math.random() * short_id_constants_1.SHORT_ID_CHARS.length));
    }
    return code;
}
//# sourceMappingURL=generate-short-id.js.map